import React, { useCallback } from 'react';
import styled from 'styled-components';
import useModal from '../../../hooks/useModal';
import WalletProviderModal from 'components/WalletProviderModal';
import MyWalletModal from 'components/MyWalletModal';
import { Trans } from 'react-i18next';
import { useTokenBalance } from 'hooks/useTokenBalance';
import { TOKENS } from 'config/constants/tokens';
import { useWeb3React } from '@web3-react/core';
import { toTokenUnitsBN } from 'utils/number';
import { useMediaQuery } from '@material-ui/core';
import BigNumber from 'bignumber.js';

const SELECT_TOKEN = TOKENS.BNB;

const AccountButton: React.FC = () => {
	const [onPresentWalletProviderModal] = useModal(<WalletProviderModal />);
	const [onPresentMyWalletModal] = useModal(<MyWalletModal />);

	const { account } = useWeb3React();
	const [balance] = useTokenBalance(SELECT_TOKEN, account);

	const handleUnlockClick = useCallback(() => {
		onPresentWalletProviderModal();
	}, [onPresentWalletProviderModal]);

	const onClickWallet = useCallback(() => {
		onPresentMyWalletModal();
	}, [onPresentMyWalletModal]);

	return (
		<StyledAccountButton>
			{!account ? (
				<StyledWalletButton onClick={handleUnlockClick}>
					<StyleTextButton>
						<Trans>Connect Wallet</Trans>
					</StyleTextButton>
				</StyledWalletButton>
			) : (
				<React.Fragment>
					<StyledBalanceInfo className="balance">
						<StyleTextButton>
							{`${toTokenUnitsBN(balance, SELECT_TOKEN.decimals).toFixed(4)} BNB`}
						</StyleTextButton>
					</StyledBalanceInfo>

					<StyledWalletButton onClick={onClickWallet} className="address">
						<StyleTextButton>
							{`${account.substring(0, 6)}...${account.substring(
								account.length - 4,
								account.length
							)}`}
						</StyleTextButton>
					</StyledWalletButton>
				</React.Fragment>
			)}
		</StyledAccountButton>
	);
};

const StyledAccountButton = styled.div`
	display: flex;
	border-radius: 32px;
	height: 48px;

	background: linear-gradient(
		270deg,
		rgba(233, 96, 175, 0.4) -10.61%,
		rgba(243, 198, 34, 0.4) 112.88%
	);

	@media (max-width: 420px) {
		height: 36px;
		margin-left: 8px;
	} ;
`;

const StyledWalletButton = styled.button`
	display: flex;
	align-items: center;

	background: linear-gradient(270deg, #e960af -10.61%, #f3c622 112.88%);
	border-radius: 32px;

	outline: none;
	border: 0;
	cursor: pointer;
	height: 100%;

	padding: 14px 16px;

	@media (max-width: 425px) {
		padding: 14px 16px;
		font-size: 11px;
	} ;
`;

const StyleTextButton = styled.span`
	letter-spacing: 0.5px;
	font-size: 16px;
	font-weight: bold;
	color: #fff;
	height: fit-content;
	line-height: 1;
	min-height: 13px;

	@media (max-width: 1200px) {
		font-size: 12px !important;
	}
`;

const StyledBalanceInfo = styled.div`
	padding: 14px 16px;
	display: block;

	@media (max-width: 425px) {
		max-width: 80px;
		min-width: 65px;
		font-size: 11px;
		padding: 14px 8px 14px 16px;
	}
`;

export default AccountButton;
